import { RoleStrings } from '@app/enums/Role';

/**
 * Whether someone is asked surveys and questionnaires in this cohort: anyone whose cohort role
 * includes Participant, whatever else they are. A captain, coach or admin who is also a
 * participant is asked; one who isn't, isn't. Roles are stored pipe-separated, e.g. "Participant|Captain".
 */
export const isAskedSurveys = (cohortRole: string | null | undefined): boolean =>
  (cohortRole ?? '').split('|').includes(RoleStrings.Participant);
